<template>
</template>

<script lang="tsx">
import { createComponent, onBeforeMount, onMounted } from '@vue/composition-api'
import { useStore } from '@/store/index'
import domain from '@/config/domain'
import { getQueryString } from '@/utils/index'
import { openNewRenew } from '@/components/new_renew/new_renew.tsx'
import { openNotifyIsImporting } from '@/components/notify_is_importing/notify_is_importing.tsx'
import { openWarning } from '../../utils/system'

export default createComponent({
    setup: (props, ctx) => {
        const modules = [{
            linkHref: '/main/dataCenter',
            name: '店铺数据',
            privilegeId: 3,
        }, {
            linkHref: '/main/goodsLibrary',
            name: '商品',
            privilegeId: 0
        }, {
            linkHref: '/main/orderForm',
            name: '订单',
            privilegeId: 0
        }, {
            linkHref: '/main/member',
            name: '会员',
            privilegeId: 4
        }, {
            linkHref: '/main/staff',
            name: '员工',
            privilegeId: 0
        }, {
            linkHref: '/main/market',
            name: '营销玩法',
            privilegeId: 4
        }, {
            linkHref: '/main/configuration',
            name: '设置',
            privilegeId: 5
        }]
        const redirect = ctx.root.$route.query.redirect as string
        const shopId = getQueryString(redirect, 'shopId') || localStorage.getItem('shopId')
        const toRenew = getQueryString(redirect, 'toRenew')
        const token = getQueryString(redirect, 'token') // 收银台带过来的token
        if (!shopId) {
            window.location.href = domain.center
        }
        localStorage.setItem('shopId', shopId as string)
        const store = useStore()

        onBeforeMount(() => {
            if (store.getters['shop/canIGoIn']()) {
                initPrivilege()
            } else {
                store.dispatch('init', {
                    token
                }).then(() => {
                    initPrivilege()
                })
            }
        })

        function initPrivilege() {
            if (redirect) {
                const moduleCanGoIn = modules.find(m => store.getters['shop/canIUse'](m.privilegeId))
                const redirectModule = modules.find(m => redirect.includes(m.linkHref))
                if (redirectModule != null && !store.getters['shop/canIUse'](redirectModule.privilegeId)) {
                    if (moduleCanGoIn) {
                        const pushParams = {
                            path: moduleCanGoIn.linkHref,
                            query: {}
                        }
                        ctx.root.$router.push(pushParams)
                    }
                } else {
                    ctx.root.$router.push({
                        path: redirect
                    })
                }
                judgeIsFirst()
                judgeIsOpenRenew()
                judgeIsImporting()
            } else {
                ctx.root.$router.push('/main')
            }
        }

        function judgeIsOpenRenew() {
            if (toRenew === 'true') {
                // openNewRenew()
            }
        }

        function judgeIsFirst() {
            const isFirstLogin = localStorage.getItem('IS_FIRST_LOGIN') ? false : true
            if (isFirstLogin) {
                localStorage.setItem('IS_FIRST_LOGIN', JSON.stringify(1))
                openWarning({
                    title: '系统提示',
                    type: 'primary',
                    render(h) {
                        return (
                            <div class="align-c fs-14 fw-500 color-333"
                                style="line-height: 20px">
                                <p>您好，欢迎进入零售后台，</p>
                                <p>为保证您的正常使用，请前往“设置-店铺信息”中</p>
                                <p>下载 森果收银台、森果零售通</p>
                            </div>
                        )
                    },
                    confirmBtnText: '立即下载',
                    cancelBtnText: '稍后下载'
                }).then(() => {
                    window.open(domain.cashier + '#/downloadNavigation')
                }, () => {})
            }
        }

        function judgeIsImporting() {
            openNotifyIsImporting()
        }
    }
})
</script>
